import { createType } from '../utils/helpers';
import { generateTypes } from '../utils/HttpReducerHelper';

export const fundingSearchProfile = generateTypes('FUNDING_SEARCH_PROFILE', 'PROFILE');
export const removeDocument = generateTypes('FUNDING_SEARCH_PROFILE', 'REMOVE_DOCUMENT');
export const uploadDocuments = generateTypes('FUNDING_SEARCH_PROFILE', 'UPLOAD_DOCUMENTS');
export const updateProfileSection = generateTypes(
  'FUNDING_SEARCH_PROFILE',
  'UPDATE_PROFILE_SECTION',
);
export const markProfileSectionAsComplete = generateTypes(
  'FUNDING_SEARCH_PROFILE',
  'MARK_PROFILE_SECTION_AS_COMPELTE',
);
export const needUpdateProfileSection = generateTypes(
  'FUNDING_SEARCH_PROFILE',
  'NEED_UPDATE_PROFILE_SECTION',
);
export const REQUEST_AUTO_SAVE_PROFILE_SECTION = createType(
  'FUNDING_SEARCH_PROFILE',
  'REQUEST_AUTO_SAVE_PROFILE_SECTION',
);
export const serviceabilityScore = generateTypes('FUNDING_SEARCH_PROFILE', 'SERVICEABILITY_SCORE');
export const serviceabilityPriceEstimates = generateTypes(
  'FUNDING_SEARCH_PROFILE',
  'PRICE_ESTIMATES',
);
export const SET_SNAPSHOT_CREATING = 'platfi-ui-app/CASE/SET_SNAPSHOT_CREATING';
// SSE Event
export const SSE_UPDATE_SNAPSHOT_GENERATION_PROGRESS = '@@SSE/entity/ledger/snapshot/generation';
export const SSE_UPDATE_SNAPSHOT_PROFILE_PROGRESS = '@@SSE/entity/ledger/profile/update';
